module.exports = __webpack_public_path__ + "img/dy-icon.859cc807.png";